import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { addCommonParams, addCommonHeaders } from '../helpers';

// 支持动态参数获取
export const createCommonParamsMiddleware = (
  getParams: Record<string, any> | (() => Record<string, any>) = {},
  getHeaders: Record<string, any> | (() => Record<string, any>) = {},
) => {
  return {
    onRequest: async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
      const params = typeof getParams === 'function' ? getParams() : getParams;
      const headers = typeof getHeaders === 'function' ? getHeaders() : getHeaders;
      addCommonParams(config, params);
      if (Object.keys(headers).length > 0) {
        await addCommonHeaders(config, headers);
      }
      return config;
    },
    onResponse: (response: AxiosResponse): AxiosResponse => {
      return response;
    },
  };
};
export type CreateParamsHeaderMiddlewareCallback = typeof createCommonParamsMiddleware;
